

import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


const dataList = [{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABc CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"1000.00"
}]

export default {
components: {
XHeader,
Tab,
TabItem
},
data () {
return {
tabIndex:0,//tab第几项
classifyList:['全部','0-100','101-500','501-1000'],
dataList:dataList
}
},
methods: {
switchTabItem(item,index) {
console.log(item + " " + index)
},
}
}



// WEBPACK FOOTER //
// ./src/views/score/list.vue